import { defineStore } from 'pinia';
import { ref } from 'vue';
import { fetchBalance, type BalanceRecord } from '@/api/balance';

export const useBalanceStore = defineStore('balance', () => {
  const balance = ref(0);
  const balanceList = ref<BalanceRecord[]>([]);
  const loading = ref(false);
  let latestRequestId = 0;

  async function refreshBalance() {
    const requestId = latestRequestId + 1;
    latestRequestId = requestId;
    loading.value = true;

    try {
      const data = await fetchBalance();
      if (requestId !== latestRequestId) return true;

      balance.value = data.balance;
      balanceList.value = data.list;
      return true;
    } catch (error) {
      console.error(error, 'refreshBalance error');
      return false;
    } finally {
      if (requestId === latestRequestId) loading.value = false;
    }
  }

  function resetBalance() {
    latestRequestId += 1;
    balance.value = 0;
    balanceList.value = [];
    loading.value = false;
  }

  return {
    balance,
    balanceList,
    loading,
    refreshBalance,
    resetBalance
  };
});
